import { Chart, ChartConfiguration, registerables } from "chart.js";
import { arrInfIndex, rand } from "../../../../../_utilities";
import { ColorSets } from "../../../../../_colorSets";
import { Colors } from "../../../../../tokens/ts/_colors";
import { HistogramProps } from "./_types";
Chart.register(...registerables);

export function histogram(
  canvas: HTMLCanvasElement,
  config: HistogramProps,
  chartJSConfig?: Partial<ChartConfiguration>
) {
  if (typeof config.colors == "string") {
    config.colors = ColorSets.charts[config.colors];
  }
  const DEFAULT_COLORS = (config?.colors ?? ColorSets.charts.blues) as Colors[];

  const options: any = {
    type: "bar",
    data: {
      labels: config.data.labels,
      datasets: config.data.datasets.map(({ label, data }, i) => ({
        label,
        data,
        backgroundColor: arrInfIndex(DEFAULT_COLORS, i),
        borderColor: arrInfIndex(DEFAULT_COLORS, i),
        borderWidth: 1,
      })),
    },
    options: {
      scales: {
        xAxis: [
          {
            ticks: {
              padding: 16,
              fontColor: Colors.n600,
            },
            gridLines: {
              drawTicks: false,
              color: Colors.n300,
            },
          },
        ],
        yAxes: [
          {
            ticks: {
              padding: 16,
              fontColor: Colors.n600,
            },
            gridLines: {
              drawTicks: false,
              color: Colors.n300,
            },
          },
        ],
      },
      plugins: {
        legend: {
          display: config.legend ?? false,
        },
      },
      layout: {
        padding: {
          left: 2,
          right: 2,
          top: 2,
          bottom: 20,
        },
      },
      reponsive: true,
    },
    ...chartJSConfig,
  };

  const context = canvas.getContext("2d");
  if (context) {
    const chart = new Chart(context, options);
    return chart;
  }
  return null;
}
